// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271634/js/" + chunkId + "." + {"44":"0cd5efb7","225":"4f708381","481":"afa0612f","486":"40fd6611","770":"c52bedac"}[chunkId] + ".0.19203991951135635.chunk.js";
};